var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("The system has been failure, please contact the administrator!")]),_c('a-button',{attrs:{"size":"small"},on:{"click":function (){this$1.visibles = !this$1.visibles}}},[_vm._v("\n    Show Details\n  ")]),_c('br'),(_vm.visibles)?_c('div',{staticStyle:{"max-height":"150px","overflow":"auto"}},[_vm._v("\n    "+_vm._s(_vm.valueError)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }